import React                   from 'react';
import PlaceItem               from './PlaceItem';
import Truncate                from 'react-truncate';
import { displayDistance }     from './../classes/Distance';
import './../css/PlaceList.css';

class PlaceGridItem extends PlaceItem
{
    render = () =>
    {
        let { place } = this.props;
        let distance;

        if (this.props.place.distance)
        {
            distance = displayDistance(this.props.place.distance, '');
        }

        let image;
        let imageData = this.resolveMainImage(place);

        if (null !== imageData)
        {
            image = (
                <div>
                    <div className="img-magic" />
                    <img style={{ flex: 1 }}  src={ imageData.url } alt={ imageData.altText } />
                </div>
            );
        }

        return (
            <li
                onTouchTap={ this.resolveClickEvent(place).bind(this, place) }
            >
                <div className="img-container">
                    { image }
                </div>
                <div className="clear grid-item-top">
                    <div className="grid-item-name">
                        <h3>{ place.name }</h3>
                    </div>
                    <div className="grid-item-distance">
                        { distance }
                    </div>
                </div>
                <p>
                    <Truncate
                        lines={ 3 }
                    >
                        { this.resolveIntro(place) }
                    </Truncate>
                </p>
            </li>
        );
    }

}

export default PlaceGridItem;



// WEBPACK FOOTER //
// ./src/components/PlaceGridItem.js